import {
  type SerializedRequest,
  type SerializedResponse,
} from '@wellesley/openapi'
import { createAction } from './helpers/createAction'

export * from './hostActions'
export * from './remoteActions'
export * from './localStorage'
export * from './toast'
export * from './theme'

export const requestMicroFrontendFetch = createAction<{
  id: string | number
  options: SerializedRequest
}>('requestMicroFrontendFetch')
export const sendMicroFrontendFetchResponse = createAction<{
  id: string | number
  response: SerializedResponse
}>('sendMicroFrontendFetchResponse')
